/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function ArticleMedium(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.01172 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={24.07031}
        y1={56.00094}
        x2={40.07031}
        y2={56.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={120.07031}
        y1={56.00094}
        x2={136.07031}
        y2={56.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={24.07031}
        y1={136.00094}
        x2={48.07031}
        y2={136.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={112.07031}
        y1={136.00094}
        x2={136.07031}
        y2={136.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={168.07031}
        y1={104.00094}
        x2={240.07031}
        y2={104.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={168.07031}
        y1={136.00094}
        x2={240.07031}
        y2={136.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={72.07031}
        y1={168.00094}
        x2={240.07031}
        y2={168.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={72.07031}
        y1={200.00094}
        x2={240.07031}
        y2={200.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="40.07 136.001 40.07 56.001 80.07 120.001 120.07 56.001 120.07 136.001"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={24.07031}
        y1={56.00094}
        x2={40.07031}
        y2={56.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={120.07031}
        y1={56.00094}
        x2={136.07031}
        y2={56.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={24.07031}
        y1={136.00094}
        x2={48.07031}
        y2={136.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={112.07031}
        y1={136.00094}
        x2={136.07031}
        y2={136.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={168.07031}
        y1={104.00094}
        x2={240.07031}
        y2={104.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={168.07031}
        y1={136.00094}
        x2={240.07031}
        y2={136.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={72.07031}
        y1={168.00094}
        x2={240.07031}
        y2={168.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={72.07031}
        y1={200.00094}
        x2={240.07031}
        y2={200.00094}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="40.07 136.001 40.07 56.001 80.07 120.001 120.07 56.001 120.07 136.001"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default ArticleMedium;
